import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useAuth } from "./auth/AuthContext.js";

export default function LoginPage() {
  const auth = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPw, setNewPw] = useState("");
  const [code, setCode] = useState("");
  const [resetPw, setResetPw] = useState("");

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="llogo"><img className="brandmark" src="/mizpah-logo.jpg" alt="Mizpah Center for Allied Health Education" /> Mizpah</div>

        {auth.status === "signedOut" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.signIn(email.trim(), password); }}>
            <h1>Admin sign in</h1>
            <p className="sub">For Mizpah owners.</p>
            {auth.notice && <div className="login-note" role="status">{auth.notice}</div>}
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
            <button className="login-btn" type="submit">Sign in</button>
            <button type="button" className="login-link" onClick={() => auth.startForgot()}>Forgot password?</button>
          </form>
        )}

        {auth.status === "forgot" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.requestReset(email.trim()); }}>
            <h1>Reset your password</h1>
            <p className="sub">Enter your admin email and we'll send a reset code.</p>
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
            <button className="login-btn" type="submit">Send reset code</button>
            <button type="button" className="login-link" onClick={() => auth.backToSignIn()}>Back to sign in</button>
          </form>
        )}

        {auth.status === "reset" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.confirmReset(code, resetPw); }}>
            <h1>Enter your reset code</h1>
            <p className="sub">We emailed a code to {auth.email || "your email"}. Enter it with a new password (12+ chars, mixed case, number, symbol).</p>
            <label>Reset code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" />
            <label>New password</label>
            <input type="password" value={resetPw} onChange={(e) => setResetPw(e.target.value)} autoComplete="new-password" />
            <button className="login-btn" type="submit">Change password</button>
            <button type="button" className="login-link" onClick={() => auth.backToSignIn()}>Back to sign in</button>
          </form>
        )}

        {auth.status === "newPassword" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.completeNewPassword(newPw); }}>
            <h1>Set a new password</h1>
            <p className="sub">First sign-in - choose a password (12+ chars, mixed case, number, symbol).</p>
            <label>New password</label>
            <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} autoComplete="new-password" />
            <button className="login-btn" type="submit">Continue</button>
          </form>
        )}

        {auth.status === "mfaSetup" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.verifyMfaSetup(code.trim()); }}>
            <h1>Set up your authenticator</h1>
            <p className="sub">Open Google Authenticator (or 1Password / Authy), tap <strong>+ → Scan a QR code</strong>, then enter the 6-digit code it shows.</p>
            {auth.mfaSecret && (
              <div style={{ display: "grid", placeItems: "center", margin: "8px 0 16px" }}>
                <QRCodeSVG
                  value={`otpauth://totp/${encodeURIComponent("Mizpah Admin")}:${encodeURIComponent(auth.email)}?secret=${auth.mfaSecret}&issuer=${encodeURIComponent("Mizpah Admin")}`}
                  size={190}
                  marginSize={2}
                  bgColor="#ffffff"
                  fgColor="#0d2a5e"
                />
              </div>
            )}
            <details>
              <summary className="sub" style={{ cursor: "pointer" }}>Can't scan? Enter this key manually</summary>
              <div className="secret">{auth.mfaSecret}</div>
            </details>
            <label>6-digit code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" />
            <button className="login-btn" type="submit">Verify</button>
          </form>
        )}

        {auth.status === "mfa" && (
          <form onSubmit={(e) => { e.preventDefault(); auth.submitMfaCode(code.trim()); }}>
            <h1>Enter your code</h1>
            <p className="sub">6-digit code from your authenticator app.</p>
            <label>Code</label>
            <input value={code} onChange={(e) => setCode(e.target.value)} inputMode="numeric" autoComplete="one-time-code" />
            <button className="login-btn" type="submit">Verify</button>
          </form>
        )}

        {auth.error && <div className="login-err" role="alert">{auth.error}</div>}
      </div>
    </div>
  );
}
